import { render, staticRenderFns } from "./TicketsView.vue?vue&type=template&id=0c862285&scoped=true&"
import script from "./TicketsView.vue?vue&type=script&lang=js&"
export * from "./TicketsView.vue?vue&type=script&lang=js&"
import style0 from "./TicketsView.vue?vue&type=style&index=0&id=0c862285&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c862285",
  null
  
)

export default component.exports